const absoluteUrlRegex = /^((([a-z-_]+:)?\/\/)|mailto:|tel:)/i;

export function isAbsoluteUrl(url: string): boolean {
    return absoluteUrlRegex.test(url);
}
